import React from 'react';
import { useSelector } from 'react-redux';
import LoadingScreen from '../../../app/components/layout/LoadingScreen';
import { selectCurrentUser } from '../../../app/store/userSelectors';

const AdminGuard = ({ children }) => {
    const user = useSelector(selectCurrentUser);

    if (!user) {
        return <LoadingScreen text='Загрузка страницы...' />;
    }

    const adminsEnv = process.env.REACT_APP_ADMINS || '';
    const admins = adminsEnv
        .split(',')
        .map((s) => s.trim())
        .filter(Boolean);

    const isAdmin = admins.includes(String(user.id));

    if (!isAdmin) {
        return null;
    }

    return children;
};

export default AdminGuard;
